import { createBrowserHistory } from 'history';
import ReactGA from 'react-ga';

const name = ''; //'web_beta' '/participa';

export const history = createBrowserHistory({ basename: name });

history.listen(location => ReactGA.pageview(location.pathname));
